export default class BTableConfigPagination {
    public backend: boolean;
    public simple: boolean;
    public total: number;
    public perPage: number;
    public currentPage: number;
    public sizeCss: string;
    public labels: BTableConfigPaginationLabel;
    constructor() {
        this.backend = true;
        this.simple = false;
        this.total = 0;
        this.perPage = Number.parseFloat(process.env.VUE_APP_PAGE_SIZE as any) || 10;
        this.currentPage = 1;
        this.sizeCss = 'is-medium';
        this.labels = new BTableConfigPaginationLabel();
    }
    public change!: (page: Number) => void;
}

export class BTableConfigPaginationLabel {
    public next: string;
    public previous: string;
    public page: string;
    public current: string;
    constructor() {
        this.next = 'Siguiente';
        this.previous = 'Anterior';
        this.page = 'Página';
        this.current = 'Página actual';
    }
}